/**
 * Created by Kirill Mashchenko on 07.07.2018.
 */

/**
 * @class Layer for push robot settings.
 * @extends PlayerRobotSettingsLayer
 * @constructor
 * @param {pm.AbstractRobot} robot Robot which settings need to display.
 */
var TrainRobotSettingsLayer = PlayerRobotSettingsLayer.extend(/** @lends PushRobotSettingsLayer# */{
	ctor: function(robot)
	{
		this._super(robot);

		this._label.setString(LocalizedString("Train") + " " + robot.id + ", " + LocalizedString("Pattern") + " " + robot.parentLevel.programData[robot.groupID].currentIndex);
	}
});
